import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./FriosNavigate.css";

export default function FriosNavigate() {
  const [categorias, setCategorias] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function carregarCategorias() {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/categorias/listar"
        );
        const data = await response.json();

        // ✅ filtra pela localizacao
        const filtradas = data.filter(
          (categoria) => categoria.localizacao === "friosnavigate"
        );

        setCategorias(filtradas);
      } catch (error) {
        console.error("Erro ao carregar categorias:", error);
      }
    }

    carregarCategorias();
  }, []);

  if (categorias.length === 0) return null;

  return (
    <div className="foodpart02-categories">
      <ul>
        {categorias.map((categoria) => (
          <li
            key={categoria.id}
            onClick={() => navigate(`/categorias/${categoria.codgrupo}`)}
          >
            {categoria.descricao}
          </li>
        ))}
      </ul>
    </div>
  );
}
